<script setup lang="ts">
/**
 * UpdateBanner.vue — the only UI surface that can trigger a PWA update.
 * Mounted once in App.vue so it's visible on every screen (including
 * LoginView). Shows nothing until a new service worker is actually waiting
 * (needRefresh, set by main.ts's onNeedRefresh). Tapping "Actualizar" is
 * the ONLY path to applyUpdate() — never automatic, per the documented
 * incident in vite.config.ts (a silent reload once stranded a login
 * mid-flow).
 */
import { needRefresh, applyUpdate } from '../lib/pwa-update.js';
</script>

<template>
  <div
    v-if="needRefresh"
    class="update-banner"
    role="status"
  >
    <span>Hay una nueva versión disponible.</span>
    <button
      type="button"
      class="update-banner-button"
      @click="applyUpdate"
    >
      Actualizar
    </button>
  </div>
</template>

<style scoped>
.update-banner {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.75rem 1rem max(0.75rem, env(safe-area-inset-bottom));
  background: #0b1220;
  color: #ffffff;
  font-size: 0.85rem;
  box-shadow: 0 -6px 20px rgba(0, 0, 0, 0.25);
}

.update-banner-button {
  flex-shrink: 0;
  border: none;
  border-radius: 0.6rem;
  padding: 0.5rem 0.9rem;
  font-weight: 700;
  font-size: 0.85rem;
  color: #ffffff;
  background: linear-gradient(90deg, #1c93ec 0%, #6d28f5 100%);
  cursor: pointer;
}
</style>
